import { AudioService } from "@fidget/common/services/audioService";

import MessageAudio from "../assets/message.mp3";

export class RingtoneService extends AudioService {
  constructor() {
    super([{ name: "message", content: MessageAudio }]);
  }

  playMessageSound() {
    this.play("message");
  }
}

export const foreRingtoneService = new RingtoneService();
